export enum CloseInvoiceTransactionStatus {
    New = 0,
    UnderProcess = 1,
    Close = 2,
}
